import styled, { css } from "styled-components";
import { zIndex } from "../../constants";
import Filters from "../Filters";
import FiltersButton from "../FiltersButton";
import MapButtons from "../MapButtons";
import LegendComponent from "../Legend";

// Shared by every map's slide-in panel (filters panel, district detail
// panel): full-bleed on mobile, a fixed-width sidebar pinned to the left
// edge on desktop.
export const panelStyles = css`
  position: absolute;
  z-index: ${zIndex.panel};
  height: 100%;
  width: 100%;

  @media (min-width: 640px) {
    top: 0;
    bottom: 0;
    width: 310px;
  }
`;

export const FiltersPanel = styled(Filters)`
  ${panelStyles}
`;

// Hidden on mobile (the filter panel's own toggle button is used instead);
// shown as a floating pill on desktop. Position defaults to the
// School/State maps' placement (top-right); pass $top/$side to override.
export const MapFiltersButton = styled(FiltersButton)`
  display: none;

  @media (min-width: 640px) {
    display: flex;
    position: absolute;
    top: ${(props) => props.$top || "70px"};
    z-index: ${zIndex.mapControl};
    ${(props) =>
      props.$side === "left"
        ? css`
            left: 20px;
          `
        : css`
            right: 20px;
          `}
  }
`;

// Repositions the zoom/reset control stack to clear the bottom view-toggle
// row used on the State map type.
export const MapButtonsPanel = styled(MapButtons)`
  bottom: 20px !important;

  @media (min-width: 640px) {
    bottom: 90px !important;
  }
`;

// Pins the legend to the bottom edge on desktop, where it's shown inline
// at all times (the State map shows its view toggle at the top, so the
// legend doesn't need extra clearance there the way StatesMap's
// bottom-anchored toggle does). Below 640px it keeps the base Legend's own
// fly-out position/animation, anchored by the key toggle instead.
export const MapLegend = styled(LegendComponent)`
  @media (min-width: 640px) {
    bottom: 10px;
  }
`;

// Keeps the map invisible until its initial fitBounds() has been applied,
// so the hand-picked placeholder zoom/center (visible for one frame before
// that runs) never flashes on screen — it just fades in already framed
// correctly.
export const MapFadeIn = styled.div`
  width: 100%;
  height: 100%;
  opacity: ${(props) => (props.$ready ? 1 : 0)};
  transition: opacity 0.15s ease-out;
`;
